import { useState } from 'react'
import { DatePicker } from '@/components/ui/DatePicker'
import { showValidationMessage } from '@/lib/utils/notifications'
import { ResidentDialogShell } from './ResidentDialogShell'
import type { LeaseEndDateDialogProps } from '../../types'



export function LeaseEndDateDialog({
  isOpen,
  onClose,
  onSubmit,
  title = 'Move Out Date',
}: LeaseEndDateDialogProps) {
  const [moveoutDate, setMoveoutDate] = useState('')

  // Angular lease-end-date.component: [max]="todaysDate" [min]="oldCenturyDate" (getCenturyFormat(1) = 01-01-1900).
  const todaysDate = new Date()
  const oldCenturyDate = new Date(1900, 0, 1)

  return (
    <ResidentDialogShell
      isOpen={isOpen}
      title={title}
      onClose={onClose}
      panelDataTestId="lease-end-date-dialog-panel"
      footer={
        <div
          className="flex flex-col-reverse gap-2 sm:flex-row sm:justify-end"
          data-testid="lease-end-date-dialog-footer"
        >
          <button
            type="button"
            onClick={onClose}
            data-testid="lease-end-date-dialog-cancel-button"
            className="w-full rounded-lg border border-slate-200 px-3 py-2 text-sm font-semibold sm:w-auto"
          >
            Cancel
          </button>
          <button
            type="button"
            disabled={!moveoutDate}
            onClick={() => {
              if (!moveoutDate) {
                showValidationMessage('Move Out Date is required.')
                return
              }
              onSubmit(moveoutDate)
              onClose()
            }}
            data-testid="lease-end-date-dialog-submit-button"
            className="w-full rounded-lg bg-button px-3 py-2 text-sm font-semibold text-white sm:w-auto disabled:cursor-not-allowed disabled:bg-slate-300 disabled:text-slate-500"
          >
            Save
          </button>
        </div>
      }
    >
      <div className="space-y-3" data-testid="lease-end-date-dialog-body">
        <p className="text-sm text-slate-700">
          Please set Move Out Date to mark record as Closed - Early End.
        </p>
        <label className="block text-sm font-medium text-slate-700">
          Move Out Date
          <DatePicker
            value={moveoutDate}
            onChange={setMoveoutDate}
            minDate={oldCenturyDate}
            maxDate={todaysDate}
            showHelperText={false}
            popperFixed
            className="mt-1 h-10 w-full rounded-lg border border-slate-200 px-3"
          />
        </label>
      </div>
    </ResidentDialogShell>
  )
}
